<template>
  <div>
    <el-card>
      <el-form :model="queryForm" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <el-select v-model="queryForm.params.orderType" size="mini">
                  <!--安骏订单号-->
                  <el-option :key="1" :label="$t('navbar.anjunOrderNumber')" :value="1" />
                  <!--客户订单号-->
                  <el-option :key="2" :label="$t('collectionCenter.customerOrderNum')" :value="2" />
                </el-select>
              </template>
              <el-input
                v-model="queryForm.params.orderNumbers"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="3"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--客户名称-->
            <el-form-item :label="$t('collectionCenter.CustomerName')">
              <el-select
                v-model="queryForm.params.customerId"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%;"
                @visible-change="getCustomerPage()"
              >
                <el-option
                  v-for="(item, ind) in customerList"
                  :key="ind"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('basicData.OperationTime')">
              <el-date-picker
                v-model="determine"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale==='zh'?zhDate:ptDate"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                size="small"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <div style="margin-top: 28px;">
              <!--搜索-->
              <el-button size="small" type="primary" @click="enterGetSearch">{{ $t('newOrder.search') }}</el-button>
              <!--重置-->
              <el-button
                size="small" style="margin-left: 20px" type="info"
                @click="resetData"
              >{{ $t('newOrder.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <!--勾选导出-->
        <el-button size="small" type="primary" @click="selectExportOrder">{{ $t('collectionCenter.export1') }}</el-button>
        <!--全部导出-->
        <el-button size="small" type="primary" @click="allExportOrder">{{ $t('collectionCenter.allExport') }}</el-button>
      </div>
      <el-table :data="tableData" border @selection-change="selectedDataChange">
        <el-table-column type="selection" width="55" align="center" />
        <!-- 序号 -->
        <el-table-column
          :label="$t('collectionCenter.ind')" align="center" type="index"
          width="60"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--安骏订单号-->
        <el-table-column
          :label="$t('navbar.anjunOrderNumber')"
          prop="orderNumber"
          align="center"
          min-width="120"
        />
        <!--客户订单号-->
        <el-table-column
          :label="$t('collectionCenter.customerOrderNum')"
          prop="customerNumber"
          align="center"
          min-width="120"
        />
        <!--客户名称-->
        <el-table-column
          :label="$t('collectionCenter.CustomerName')"
          prop="customerName"
          align="center"
          min-width="120"
        />
        <!--协议名称-->
        <el-table-column
          :label="$t('collectionCenter.AgreementName')"
          prop="agreementName"
          align="center"
          min-width="180"
        />
        <!--操作-->
        <el-table-column
          :label="$t('collectionCenter.operation')"
          prop="operationName"
          align="center"
          min-width="100"
        />
        <!--操作时间-->
        <el-table-column
          :label="$t('operationCenter.operationTime')"
          prop="operationTime"
          align="center"
          min-width="120"
        >
          <template slot="header">
            <div>
              <span>{{ $t('operationCenter.operationTime') }}</span>
              <el-tooltip
                class="item" effect="dark" :content="$t('collectionCenter.userClicksTime')"
                placement="top"
              >
                <span class="timeTips">?</span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.operationTime }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 200, 400]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 20px 0; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
  </div>
</template>

<script>
import { CustomerPage } from '@/api/customer';
import { agreementRecordExport, agreementRecordPage } from '@/api/bulkyExpress';
import { goResourceTaskList } from '@/utils/goExportList';
import dayjs from 'dayjs';
export default {
  name: 'ProtocolRecord',
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          orderNumbers: '',
          orderType: 1,
          customerId: ''
        }
      },
      determine: [],
      customerList: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      tableData: [],
      selectedData: []
    };
  },
  created() {
    this.getDate();
    this.enterGetSearch();
  },
  methods: {
    // 设置默认日期
    getDate() {
      const date = new Date();
      const firstDay = dayjs(date - 6 * 24 * 60 * 60 * 1000).format('YYYY-MM-DD') + ' 00:00:00';
      const lastDay = dayjs(date).format('YYYY-MM-DD') + ' 23:59:59';
      this.determine = [firstDay, lastDay];
    },
    // 获取客户
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      CustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 搜索
    enterGetSearch() {
      const param = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          orderNumbers: null, // 安骏订单号
          customerNumbers: null, // 客户单号
          customerId: this.queryForm.params.customerId || null,
          operationStartTime: this.determine?.[0] || null,
          operationEndTime: this.determine?.[1] || null
        }
      };
      if (this.queryForm.params.orderNumbers) {
        const orderNumberList = this.queryForm.params.orderNumbers.split(/[\n\r]/);
        const orderNumArr = [];
        orderNumberList.map(item => {
          const orderNum = item.replace(/\s+/g, '');
          if (orderNum) {
            orderNumArr.push(orderNum);
          }
        });
        if (orderNumArr.length > 2000) {
          this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
          return;
        }
        if (this.queryForm.params.orderType === 1) {
          param.params.orderNumbers = orderNumArr;
        } else {
          param.params.customerNumbers = orderNumArr;
        }
      }
      agreementRecordPage(param).then(res => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 重置
    resetData() {
      this.queryForm.params.orderNumbers = '';
      this.queryForm.params.orderType = 1;
      this.queryForm.params.customerId = '';
      this.determine = [];
      this.getDate();
      this.enterGetSearch();
    },
    // 勾选导出
    selectExportOrder() {
      if (this.selectedData.length > 0) {
        const ids = [];
        this.selectedData.forEach((item) => {
          ids.push(item.id);
        });
        agreementRecordExport({ ids }).then((res) => {
          if (res.code === 200) {
            goResourceTaskList();
          }
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.PleaseTickTheDataExport'));
      }
    },
    // 全部导出
    allExportOrder() {
      if (this.tableData.length > 0) {
        const param = {
          orderNumbers: null, // 安骏订单号
          customerNumbers: null, // 客户单号
          customerId: this.queryForm.params.customerId || null,
          operationStartTime: this.determine?.[0] || null,
          operationEndTime: this.determine?.[1] || null
        };
        if (this.queryForm.params.orderNumbers) {
          const orderNumberList = this.queryForm.params.orderNumbers.split(/[\n\r]/);
          const orderNumArr = [];
          orderNumberList.map(item => {
            const orderNum = item.replace(/\s+/g, '');
            if (orderNum) {
              orderNumArr.push(orderNum);
            }
          });
          if (this.queryForm.params.orderType === 1) {
            param.orderNumbers = orderNumArr;
          } else {
            param.customerNumbers = orderNumArr;
          }
        }
        agreementRecordExport(param).then(res => {
          if (res.code === 200) {
            goResourceTaskList();
          }
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
      }
    },
    // 数据勾选
    selectedDataChange(val) {
      this.selectedData = val;
    },
    // 每页显示数量
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.enterGetSearch();
    },
    // 当前页码
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.enterGetSearch();
    }
  }
};
</script>
<style>
.timeTips {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: #2c2c2c;
  color: #fff;
  border-radius: 50%;
  margin-left: 5px;
  font-size: 12px;
}
</style>
